import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Base } from '../base/base';
import { User } from '../../models/user/user.model';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends Base implements OnInit, OnDestroy {
  industry: string = '';

  public pageName = "Home";

  private readonly _destroying$ = new Subject<void>();

  constructor(private titleService: Title) {
    super();
    this.titleService.setTitle(this.basePageTitle +this.pageName);
  }

  ngOnInit(): void {
    this.user = this.getUserDetailsFromLocalStorage();
    this.industry = this.getIndustry();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}

